<template>
    <b-form-row>
        <b-modal @hidden="handleClean" v-model="showModal" size="xl" button-size="sm" ref="finder" hide-footer :id="this.id"
            :title="prefix + title">
            <ConsultarContratos :idFinderContrato="id + '-'" :processoCompra="processoCompra"
                :prefix="prefix + title + ' > '" @onDblClickContrato="contratoSelect" />
        </b-modal>

        <lg-form-input-finder v-if="!isModal" :value="computedValue" fieldDescription="numeroContrato" :label="label"
            invalidFeedback="Contrato deve ser informado!" description="" @handleClean="handleClean" :error="error"
            :cols="cols" :disabled="disabled">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"

export default {
    components: { LgFormInputFinder, ConsultarContratos: () => import("@/modules/contratos/ConsultarContratos.vue") },
    props: {
        processoCompra: {
            type: Object,
            default: null
        },
        isModal: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        id: String,
        value: Object,
        cols: String,
        label: String,
        error: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },

        title: {
            type: String,
            default: "Contratos",
        },
    },
    data() {
        return {
            showModal: this.isModal ? true : false,

            internalValue: this.value || {},
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue
            },
            set(newValue) {
                this.internalValue = newValue
            },
        },
    },
    methods: {
        show() {
            this.showModal = true;
            this.$bvModal.show(this.id)
        },
        handleClean() {
            this.showModal = false;

            this.computedValue = {}
            this.$emit("input", null)
            this.$bvModal.hide(this.id)

        },
        contratoSelect(item) {
            this.showModal = false;

            this.computedValue = item
            this.$emit("input", item)
            this.$bvModal.hide(this.id)
        },
    },
}
</script>
